<google-map *ngIf="apiLoaded | async" [center]="center" [zoom]="zoom" height="400" width="100%">
  <map-marker [position]="center" [options]="markerOptions"></map-marker>
</google-map>
